import styled from 'styled-components';
import { HeaderTitle, PageHeader } from 'ui/pageHeader';
import { body1, spacing } from 'ui/theme';
import { LOOKUP_TYPE_TO_HUMAN_READABLE_NAME } from '../constant';

import { useFormContext } from '../contexts/FormContext';

const displayText = {
  title: 'User Lookup',
  description: 'Get additional details about a user profile. Search by',
};

const Description = styled.p`
  && {
    ${body1};
    margin-top: ${spacing.base};
  }
`;

const PageSubSection = () => {
  const { availableLookupTypes } = useFormContext();
  return (
    <Description>
      {availableLookupTypes.length === 1
        ? `${displayText.description} ${
            LOOKUP_TYPE_TO_HUMAN_READABLE_NAME[availableLookupTypes[0]]
          }`
        : displayText.description}
      :
    </Description>
  );
};

export const Header = () => (
  <PageHeader documentTitle={displayText.title} pageSubSection={<PageSubSection />}>
    <HeaderTitle>{displayText.title}</HeaderTitle>
  </PageHeader>
);
